import { render, staticRenderFns } from "./Publicar.vue?vue&type=template&id=e08fa636&scoped=true"
import script from "./Publicar.vue?vue&type=script&lang=js"
export * from "./Publicar.vue?vue&type=script&lang=js"
import style0 from "./Publicar.vue?vue&type=style&index=0&id=e08fa636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08fa636",
  null
  
)

export default component.exports